/* eslint no-restricted-globals: ["off","self", "top"] */

import env from 'utilities/env';
import { getUrlParams } from 'utilities/getUrlParams';
import { get } from 'lodash';

const GRAPHQL_HOST_PARAMETER = 'graphql';
const GRAPHQL_HOST_KEY = 'graphqlHost';

const RAILS_APP_HOST_PARAMETER = 'application';
export const RAILS_APP_HOST_KEY = 'legacyApp';

const TOKEN_PARAMETER = 'token';
const ADMIN_USER_ID_PARAM = 'admin_user_id';

export const TRIGGER = 'trigger';

export const TOKEN_KEY = 'token';
export const FROM_KEY = 'from'; // localStorage key
export const RESET_PASSWORD_TOKEN_KEY = 'reset_password_token';
export const ADMIN_USER_ID = 'admin_user_id';
export const storageEngine = localStorage;

export const IS_FRAMED = self !== top; // is the current page framed?
export const FRAME_NAME = window.name; // the name of the current frame

export const getRailsUrl = (to) => {
  const host = storageEngine.getItem(RAILS_APP_HOST_KEY) || env('RAILS_HOST');
  return `${host}${to}`;
};

export const getGraphqlUrl = () => {
  const host = storageEngine.getItem(GRAPHQL_HOST_KEY) || env('GRAPHQL_HOST');
  return `${host}${env('GRAPHQL_QUERY_ROOT')}`;
};

export const getRestUrl = () => {
  // @todo this should be keyed off of a REST_HOST_KEY
  const host = storageEngine.getItem(GRAPHQL_HOST_KEY);
  return host || '';
};

const setToken = (queryVars) => {
  const newToken = get(queryVars, TOKEN_PARAMETER, null);
  if (newToken) {
    storageEngine.setItem(TOKEN_KEY, newToken);
  }
};

const setAdminUserID = (queryVars) => {
  const adminUserId = get(queryVars, ADMIN_USER_ID_PARAM, null);
  if (adminUserId) {
    storageEngine.setItem(ADMIN_USER_ID, adminUserId);
  }
};

const setGraphQlHost = (queryVars, fallback) => {
  const gqlHost = (
    get(queryVars, GRAPHQL_HOST_PARAMETER, null)
    || env('GRAPHQL_HOST')
    || storageEngine.getItem(GRAPHQL_HOST_KEY)
    || fallback
  );
  storageEngine.setItem(GRAPHQL_HOST_KEY, gqlHost);
};

const setRailsHost = (queryVars, fallback) => {
  const railsHost = (
    get(queryVars, RAILS_APP_HOST_PARAMETER, null)
    || storageEngine.getItem(RAILS_APP_HOST_KEY)
    || env('RAILS_HOST')
    || fallback
  );
  storageEngine.setItem(RAILS_APP_HOST_KEY, railsHost);
};

const setTriggerOption = (queryVars) => {
  const triggerOption = get(queryVars, TRIGGER, null);
  if (triggerOption) {
    storageEngine.setItem(TRIGGER, triggerOption);
  }
};

// store previous page route sent in from rails to localStorage
const setPreviousPage = (queryVars) => {
  const previousPage = get(queryVars, FROM_KEY, null);
  if (previousPage) {
    storageEngine.setItem(FROM_KEY, previousPage);
  }
};

const setResetPasswordToken = (queryVars) => {
  const resetPasswordToken = get(queryVars, RESET_PASSWORD_TOKEN_KEY, null);
  if (resetPasswordToken) {
    storageEngine.setItem(RESET_PASSWORD_TOKEN_KEY, resetPasswordToken);
  }
};

export const extractConfigurationFromUrl = (path) => {
  const queryVars = getUrlParams(path);
  const err = 'host-misconfigured';
  setToken(queryVars);
  setGraphQlHost(queryVars, err);
  setRailsHost(queryVars, err);
  setTriggerOption(queryVars);
  setPreviousPage(queryVars);
  setAdminUserID(queryVars);
  setResetPasswordToken(queryVars);
};
